module.exports = __webpack_public_path__ + "static/media/footorOrange.5d77196e.png";